import { Children, cloneElement, isValidElement, ReactNode } from "react";
import styled from "styled-components";
import { layout, space, typography, color } from "styled-system";
import css from "@styled-system/css";

import { ListProps } from "./list.type";

export const StyledList = styled.ul<Partial<ListProps>>`
  ${css({
    fontFamily: "normal",
    padding: 4,
  })}
  ${layout}
  ${space}
  ${typography}
  ${color}
  ${(props) => props.css}
`;

const List = ({
  fontSize = "body",
  color = "lighter-text-color",
  fontWeight = "normal",
  icon,
  iconWeight = "regular",
  iconColor = "text-color-hover",
  iconWidth = "15px",
  iconHeight = "15px",
  iconAlignment = "center",
  children,
  ...props
}: ListProps) => {
  //pass the icon  prop to all children
  const childrenWithProps = icon
    ? Children.map(
        children,
        (child: ReactNode) =>
          isValidElement(child) &&
          cloneElement(child, {
            icon:
              child.props && child.props["icon"] ? child.props["icon"] : icon,
            iconWeight:
              child.props && child.props["iconWeight"]
                ? child.props["iconWeight"]
                : iconWeight,
            iconColor:
              child.props && child.props["iconColor"]
                ? child.props["iconColor"]
                : iconColor,
            iconWidth:
              child.props && child.props["iconWidth"]
                ? child.props["iconWidth"]
                : iconWidth,
            iconHeight:
              child.props && child.props["iconHeight"]
                ? child.props["iconHeight"]
                : iconHeight,
            iconAlignment:
              child.props && child.props["iconAlignment"]
                ? child.props["iconAlignment"]
                : iconAlignment,
          })
      )
    : children;

  return (
    <StyledList
      {...props}
      fontSize={fontSize}
      color={color}
      fontWeight={fontWeight}
    >
      {childrenWithProps}
    </StyledList>
  );
};

export default List;
